import { makeToothSliceSource } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import type { ToothSliceContext } from '@/entities/composed';

import type { ToothSliceSourceState } from '../config';

const areSnapshotsReady = (context: ToothSliceContext) => {
  const { patientAssets, reportAssets, reportConditions } = context.snapshots;

  return (
    patientAssets.patientID === context.report.PatientID &&
    patientAssets.loading === 'succeeded' &&
    reportAssets.reportID === context.report.ID &&
    reportAssets.loading === 'succeeded' &&
    reportConditions.reportID === context.report.ID &&
    reportConditions.loading === 'succeeded'
  );
};

export const resolveToothSliceSourceState = (
  context: ToothSliceContext | null,
): ToothSliceSourceState => {
  if (!context) {
    return { status: 'pending', source: null };
  }

  const { patientAssets, reportAssets, reportConditions } = context.snapshots;
  const isCurrentSnapshot =
    patientAssets.patientID === context.report.PatientID &&
    reportAssets.reportID === context.report.ID &&
    reportConditions.reportID === context.report.ID;

  if (!isCurrentSnapshot) {
    return { status: 'pending', source: null };
  }

  if (
    [patientAssets, reportAssets, reportConditions].some(
      (snapshot) => snapshot.loading === 'failed',
    )
  ) {
    return { status: 'failed', source: null };
  }

  if (!areSnapshotsReady(context)) {
    return { status: 'pending', source: null };
  }

  return { status: 'succeeded', source: makeToothSliceSource(context) };
};
